export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "IMD-debitering";
};

export const detailUrl = ({ id }) => {
  return `/configcenter/rental-notifications/imd-setting/${id}`;
};
